import { Component } from '@angular/core';

@Component({
    selector: 'password-toggle',
    imports: [],
    templateUrl: './password-toggle.component.html',
    styleUrl: './password-toggle.component.scss'
})
export class PasswordToggleComponent {
  show: boolean  = false;
}
